import { FC } from 'react';
import { FieldRow, FieldLabel } from 'src/generic/component';
import { IDistance } from 'src/types/org/common/distanceSchema';
import { ErrorManager } from 'src/types/validation';
import { IFieldProps } from 'src/generic/type/form';
import { Dropdown } from 'src/components';
import { unitOptions } from 'src/constants';
import { Grid } from '@mui/material';
import { IntegerInput } from 'src/generic/component/form';
import { Draft } from 'src/types/common';

export const DistanceFields: FC<IFieldProps<IDistance>> = ({ readOnly, errors, item: initial, original, showDiff, onUpdate }) => {

  const { getError, hasError, getMessage } = ErrorManager(errors);

  const {
    distance,
    unit
  } = initial;

  const changed = (update: Draft<IDistance>) => {
    if (onUpdate) {
      onUpdate({ ...initial, ...update });
    }
  };

  return (<div>
    <FieldRow>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <FieldLabel variant="body1">Distance</FieldLabel>
          <IntegerInput name="distance" readOnly={readOnly}
            error={getError('distance') || getMessage()}
            onChange={(value) => changed({ distance: value })}
            value={distance}
          />
        </Grid>
        <Grid item xs={4}>
          <FieldLabel variant="body1">Unit</FieldLabel>
          <Dropdown disabled={readOnly}
            validation={hasError('unit') || getMessage() ? 'error' : undefined}
            validationMsg={getError('unit') || getMessage()}
            values={unitOptions}
            onChange={(value: string) => {
              changed({ unit: value });
            }} value={unit}></Dropdown>
        </Grid>
      </Grid>
    </FieldRow>
  </div>);
};